const PH_XOF = {
  prenom:     'Aminata',
  nom:        'Diallo',
  nomComplet: 'Aminata Diallo',
  email:      'aminata.diallo@gmail.com',
  telephone:  '+221 77 000 00 00',
  adresse:    'Rue 10, Mermoz, Dakar',
  notes:      'Ex : coupe courte, allergie produit X...',
};

const PH_EUR = {
  prenom:     'Sophie',
  nom:        'Martin',
  nomComplet: 'Sophie Martin',
  email:      'sophie.martin@gmail.com',
  telephone:  '+33 6 00 00 00 00',
  adresse:    '12 rue de la Paix, Paris',
  notes:      'Ex : coupe courte, allergie produit X...',
};

const PH_DEFAULT = {
  prenom:     'Votre prénom',
  nom:        'Votre nom',
  nomComplet: 'Votre nom complet',
  email:      'vous@exemple.com',
  telephone:  'Votre numéro',
  adresse:    'Votre adresse',
  notes:      'Instructions particulières...',
};

export const getPlaceholders = (devise) => {
  if (devise === 'XOF') return PH_XOF;
  if (devise === 'EUR') return PH_EUR;
  return PH_DEFAULT;
};
